module.exports = __webpack_public_path__ + "static/media/stijn-bessem-clients-voxi.72c9b58e.svg";